import React, { useState, useEffect } from "react";
import { CustomSelect } from "../CustomSelect"; // Import CustomSelect directly
import {
  GetLookupItemsByLookupTypeName,
  lookupItemsGetId,
} from "../../../Services";

function CustomlookupSelect({
  lookupName,
  lookupTypeId,
  excludeLookupByName = [],
  value,
  onSelectChanged,
  onChange,
  renderValue,
  style,
  placeholder,
  error,
  helperText,
  withError,

  ...rest
}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchLookupData = async () => {
    setIsLoading(true);
    try {
      let result;

      if (lookupTypeId) {
        result = await lookupItemsGetId({ lookupTypeId });
      } else if (lookupName) {
        const res = await GetLookupItemsByLookupTypeName({
          lookUpName: lookupName,
          pageIndex: 1,
          pageSize: 100,
        });
        result = res.result;
      }

      const filteredData = Array.isArray(result)
        ? result.filter((item) =>
            typeof excludeLookupByName === "string"
              ? item.lookupItemName.toLowerCase() !==
                excludeLookupByName.toLowerCase()
              : !excludeLookupByName.includes(item.lookupItemName.toLowerCase())
          )
        : [];

      setData(filteredData);
      return filteredData;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLookupData();
  }, [lookupName, lookupTypeId]);

  const handleChange = (selectedValue) => {
    const selectedItem = data.find(
      (item) => item.lookupItemId === selectedValue
    );

    if (onSelectChanged) {
      onSelectChanged(selectedValue, selectedItem);
    }
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <CustomSelect
      options={data}
      defaultValue={value}
      onValueChange={handleChange}
      placeholder={placeholder}
      disabled={rest.disabled || isLoading}
      getOptionLabel={(option) => option.lookupItemName}
      getOptionValue={(option) => option.lookupItemId}
      renderValue={
        renderValue &&
        ((selected) => {
          const item = data.find((i) => i.lookupItemId === selected);
          return renderValue(selected, item);
        })
      }
      width="100%"
      style={style}
      error={error}
      helperText={helperText}
      {...rest}
    />
  );
}

export default CustomlookupSelect;
